import { connect } from 'react-redux';
import get from 'lodash/get';

import {
  getMetaDataDescription,
  getMetaDataKeywords,
  getMetaDataTitle,
} from 'redux/modules/search-and-browse/selectors/meta-data';
import { getPageTitle } from 'redux/modules/search-and-browse/selectors';
import { createAisleFetcher } from 'redux/fetchers/custom-aisle';
import { withRouteProps } from 'utils/with-route-props';

import CustomAisle from './CustomAisle';

export default withRouteProps(
  connect(
    (state, props) => ({
      aisleRef: get(props, 'match.params[*]', null),
      error: state.searchAndBrowse.error,
      metaDescription: getMetaDataDescription(state),
      metaKeywords: getMetaDataKeywords(state),
      metaTitle: getMetaDataTitle(state),
      title: getPageTitle(state),
    }),
    (dispatch, props) => {
      const aisleFetcher = createAisleFetcher(props.rootCategory);
      return {
        fetchProducts: () => dispatch(aisleFetcher(props)),
      };
    },
  )(CustomAisle),
);
